import * as React from "react";
import * as FileSaver from 'file-saver';
import * as moment from 'moment';
import {Pagination} from 'react-bootstrap';
import {LoadingViewState, RouterView} from "../../RouterView";
import {kernel} from "../../../../ioc/IOCHelper";
import {HandHistoryService} from "../../../../service/poker/history/HandHistoryService";
import {Symbols} from "../../../../ioc/Symbols";
import {
    BonusPotEvent,
    GamePot,
    HandHistoryDownloadResponse,
    HandHistoryEvent,
    HandHistoryListRequest,
    HandHistoryListResponse,
    HistoricHand,
    Player,
    PotUpdate,
    TableCardsDealt
} from "../../../../../generated/protocol";
import {Form, FormListener} from "../../../form/Form";
import {FormGroup} from "../../../form/FormGroup";
import {FormInput} from "../../../form/FormInput";
import {CustomTable} from "../../../util/CustimizableTable";
import {Link} from "react-router";
import {formatDate} from "../../../util/date";
import {CardUtils} from "../../../poker/history/CardUtils";
import {FormDateTimePicker} from "../../../form/FormDateTimePicker";
import {OPERATOR_SERVICE_NAME, OperatorService} from "../../../../service/admin/OperatorService";
import {SelectInput} from "../../../form/SelectInput";
import {getJsonAsObject, keyExist, storeAsJson} from "../../../../utils/LocalStorageUtils";
import {extractPathParams, toPathParams} from "../../../../utils/UrlUtils";
import {Validators} from "../../../form/Validators";

interface State extends LoadingViewState {
    request?: HandHistoryListRequest;
    list?: HandHistoryListResponse;
    validationMap?: any;
    display?: { [key: string]: boolean };
    currencies?: string[];
    searching?: boolean;
    history?: number[];
    handId?: string;
    activePage?: number;
    newToDate?: string;
    requiredError?: boolean; // to display warning about invalid form value.
}

interface Props {
    params: any;
}

interface ColumnsType {
    [key: string]: boolean
}

interface Uint8Array {
}

interface TextDecoder {
  decode(input?: Uint8Array): string;
}

declare var TextDecoder: {
  prototype: TextDecoder;
  new(label?: string): TextDecoder;
};

const columns: ColumnsType = {
    id: true,
    tableId: false,
    tableIntegrationId: false,
    tableName: true,
    bonusAmount: true,
    community: true,
    pots: true,
    startTime: true,
    endTime: false,
    variant: true,
    betStrategyType: false,
    playerIds: false,
    playerNames: false,
    seatIds: false,
    capacity: false
}
const HAND_HISTORY_SETTINGS = "hh_settings";

export class HandHistoryListView extends RouterView<Props, State> implements FormListener<HandHistoryListRequest> {
    initial: any;
    service: HandHistoryService;
    operatorService: OperatorService;

    constructor(props: Props) {
        var params = extractPathParams({}, props.params);
        console.log("PARAMS extracted = ", params);

        let utcNow = moment.utc().toDate();
        let utcNowLess10m = moment().utc().subtract(10, 'minutes').toDate();
        params = Object.assign({}, {
            toDate: utcNow,
            fromDate: utcNowLess10m,
            limit: 50,
            currencyCode: "XCC",
            first: 0
        }, params);
        params.doCount = true;
        super(props);
        this.state = Object.assign(this.state, {
            history: [],
            handId: "",
            display: keyExist(HAND_HISTORY_SETTINGS) ? getJsonAsObject<ColumnsType>(HAND_HISTORY_SETTINGS) : columns,
            validationMap: {},
            request: params,
            list: {hands: []},
            activePage: 1
        });
        this.initial = params;

        this.service = kernel.get<HandHistoryService>(Symbols.HandHistoryService);
        this.operatorService = kernel.get<OperatorService>(OPERATOR_SERVICE_NAME);
        console.log("Hand history service", this.service);
    }

    loadContent(): Promise<any> | void {
        return new Promise<any>((resolve, reject) => {
            this.operatorService.getCurrencies().then((currencies: string[]) => {
                let currencyCode = this.state.request.currencyCode;
                if (currencies.indexOf(currencyCode) == -1) {
                    currencyCode = currencies[0];
                }
                let request = Object.assign({}, this.state.request, {
                    currencyCode: currencyCode
                });
                this.service.listHandHistory(request).then(list => {
                    this.setState({list: list, currencies: currencies, request: request});
                    resolve();
                }).catch(err => {
                    reject(err);
                })
            }).catch(err => {
                reject(err);
            })
        });

    }

    onSubmit() {
        this.state.request.doCount = true;
        this.state.request.first = 0;
        this.setState({activePage: 1});
        this.search(this.state.request, []);
    }

    download() {
        this.setState({searching: true});
        this.service.downloadHandHistory(this.state.request).then((res: HandHistoryDownloadResponse) => {
            this.saveFile(res.handHistory);
        }).catch((err) => {
            console.log(err);
            this.setState({searching: false});
        });
    }

    bulkDownload() {
        this.setState({searching: true});
        fetch('/dashboard/rest/poker/hand-history/bulk-download', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(this.state.request),
          }
        ).then(response => response.body)
            .then(body => {
                const reader = body.getReader();
                let result = '';
                const processText = ({done, value}) => {
                    if (done) {
                      this.saveFile(result);
                      this.setState({searching: false});
                      return;
                    }
                    result += new TextDecoder("utf-8").decode(value);
                    return reader.read().then(processText);
                };
                reader.read().then(processText);
            }
        ).catch(err => {
            console.error(err);
            this.setState({searching: false});
        });
    }

    saveFile(data){
      let dateString: string = moment(new Date()).format("YYYYMMDD_HHmm");
      let blob = new Blob([data], {type: "text/plain;charset=utf-8"});
      FileSaver.saveAs(blob, "hh_" + dateString + ".txt");
      this.setState({searching: false});
    }

    bulkDowloadNewBatch() {
        this.setState({searching: false});
    }

    search(request, history) {
        this.setState({searching: true, request: request, history: history});
        this.navigate("/hand-history" + toPathParams(request));
        this.service.listHandHistory(request).then((res: HandHistoryListResponse) => {
            // total count is -1 when we did not re-count, just fetched another page for the same query.
            if (res.totalCount == -1) {
                res.totalCount = this.state.list.totalCount;
            }
            this.setState({list: res, searching: false});

        }).catch(() => {
            this.setState({searching: false});
        });
    }

    formDidUpdate(formModel: HandHistoryListRequest, validationMap?: any) {
        let isFormValidated: boolean = false;

        // If one of form value is valid, it's OK to submit
        if ( (!validationMap.tableId.errorName && formModel.tableId.length > 0 && formModel.playerIds.length == 0)
            || (!validationMap.playerIds.errorName && formModel.playerIds.length > 0 && formModel.tableId.length == 0) ) {

            // Make validation ok forcely
            validationMap.playerIds.displayError = false;
            validationMap.playerIds.errorName = null;
            validationMap.tableId.displayError = false;
            validationMap.tableId.errorName = null;
        }

        // If there is no invalild form, remove warning.
        if ( !(validationMap.playerIds.displayError || validationMap.playerIds.errorName
            || validationMap.tableId.displayError || validationMap.tableId.errorName) ) {
            isFormValidated = true;
        }

        this.setState({request: formModel, validationMap: validationMap, requiredError: isFormValidated});
    }

    getEnabledClass(id: string) {
        return this.isEnabled(id) ? "btn-primary" : "btn-default";
    }

    createFilter(property: string, name: string) {
        return <a onClick={this.toggle.bind(this, property)}
                  className={"btn btn-sm " + this.getEnabledClass(property)}>{name}</a>;
    }

    toggle(id) {
        let display = Object.assign({}, this.state.display);
        display[id] = !display[id];
        storeAsJson(HAND_HISTORY_SETTINGS, display),
            this.setState({display: display});
    }

    isEnabled(id) {
        return this.state.display[id] == true;
    }

    handleChange(event: React.FormEvent) {
        var value: string;
        value = (event.target as any).value;
        this.setState({handId: value});

    }

    showHand() {
        if (this.state.handId.length > 0) {
            this.navigate("/hand/" + this.state.handId);
        }
    }

    getPageCount() {
        let total = this.state.list.totalCount;
        let limit = this.state.request.limit;
        return Math.ceil(total / limit);
    }

    handlePageSelect(eventKey) {
        let req = this.state.request;
        req.first = (eventKey - 1) * this.state.request.limit;
        req.doCount = false;
        this.setState({activePage: eventKey});
        this.search(req, history);
    }

    getPagination() {
        if (this.state.list.totalCount > this.state.request.limit) {
            return (
                <Pagination
                    prev="Previous"
                    next="Next"
                    items={this.getPageCount()}
                    activePage={this.state.activePage}
                    onSelect={this.handlePageSelect.bind(this)}/>
            );
        }
    }

    getMinDate() {
        if (this.state.request && this.state.request.toDate) {
            const date = new Date(this.state.request.toDate)
            date.setDate(date.getDate() - 7)
            return date
        }
    }

    getMaxDate() {
        if (this.state.request && this.state.request.fromDate) {
            const date = new Date(this.state.request.fromDate)
            date.setDate(date.getDate() + 7)
            return date
        }
    }

    renderContent(): JSX.Element {
        return (
            <div>
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h1>Hand History</h1>
                    </div>

                </div>
                <div className="wrapper wrapper-content animated">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h5>Find Hand</h5>
                        </div>
                        <div className="ibox-content">
                            <div className="form-horizontal row">
                                <div className="form-group">
                                    <label className="col-lg-2 control-label">Hand ID</label>
                                    <div className="col-lg-10">
                                        <input type="text" className="form-control"
                                               onChange={this.handleChange.bind(this)} value={this.state.handId}/>
                                        <span className="help-block m-b-none">The unique UUID of the hand you are looking for</span>
                                    </div>
                                </div>
                                <div className="col-lg-offset-2 col-lg-10">
                                    <input className="btn btn-primary" value="Show Hand" type="submit"
                                           onClick={this.showHand.bind(this)}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ibox float-e-margins" style={{
                        opacity: this.state.searching ? 0.5 : 1,
                        pointerEvents: this.state.searching ? "none" : "auto"
                    }}>
                        <div className="ibox-title">
                            <h5>Filter Hands</h5>
                        </div>
                        <div className="ibox-content">
                            <Form className="form-horizontal" formListener={this} modelObject={this.state.request}
                                  validationMap={this.state.validationMap}>
                                <FormGroup className="form-group" model="fromDate">
                                    <label className="col-lg-2 control-label">From Date (UTC):</label>
                                    <div className="col-lg-10">
                                        <FormDateTimePicker timeZoneId="UTC" model="fromDate" minDate={this.getMinDate()}/>
                                        <span className="help-block m-b-none">Show hands from this date</span>
                                    </div>
                                </FormGroup>
                                <FormGroup className="form-group" model="toDate">
                                    <label className="col-lg-2 control-label">To Date (UTC):</label>
                                    <div className="col-lg-10">
                                        <FormDateTimePicker timeZoneId="UTC" model="toDate" maxDate={this.getMaxDate()}/>
                                        <span className="help-block m-b-none">Show hands up to this date</span>
                                        <span className="help-block m-b-none">Maximum range of 7 days</span>
                                    </div>
                                </FormGroup>
                                <FormGroup className="form-group" model="currencyCode">
                                    <label className="col-lg-2 control-label">Currency:</label>
                                    <div className="col-lg-10">
                                        <SelectInput className="form-control" model="currencyCode"
                                                     values={this.state.currencies}/>
                                        <span className="help-block m-b-none">Table currency or Buy-in currency for tournaments</span>
                                    </div>
                                </FormGroup>
                                <FormGroup className="form-group" model="playerIds">
                                    <label className="col-lg-2 control-label">Cubeia User Id:</label>
                                    <div className="col-lg-10">
                                        <FormInput className="form-control" model="playerIds" type="text"
                                                   validators={[Validators.required()]}/>
                                        <span className="help-block m-b-none">Cubeia User Ids seperated by space.</span>
                                    </div>
                                </FormGroup>
                                <FormGroup className="form-group" model="tableId">
                                    <label className="col-lg-2 control-label">Table Integration Id:</label>
                                    <div className="col-lg-10">
                                        <FormInput className="form-control" model="tableId" type="text"
                                                   validators={[Validators.required()]}/>
                                        <span className="help-block m-b-none">Table identifier</span>
                                    </div>
                                </FormGroup>
                                <div className={`alert alert-warning ${this.state.requiredError ? 'hidden' : ''}`}>
                                    At least one of <strong>Cubeia User Ids</strong> or <strong>Table Integrated Id</strong> is required!
                                </div>
                                <FormGroup className="form-group" model="tournaments">
                                    <label className="col-lg-2 control-label">Game Type:</label>
                                    <div className="col-lg-10">
                                        <SelectInput className="form-control" model="tableType"
                                                     values={["ALL", "RING_GAME", "TOURNAMENT", "SURGE"]}/>
                                    </div>
                                </FormGroup>
                                <div className="form-group">
                                    <div className="col-lg-offset-2 col-lg-10 pager-buttons">
                                        <input className="btn btn-primary" value="Apply" type="submit"/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="col-lg-2 control-label" style={{marginTop: "20px"}}>Number of
                                        results: {this.state.list.totalCount}</label>
                                    <div className="col-lg-10">
                                        {this.getPagination()}
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </div>
                    <div>

                        <div className="ibox-title">
                            <h5>Display Columns</h5>
                        </div>
                        <div className="ibox-content">
                            <div className="row">
                                <div className="col-sm-12 column-filter-actions">
                                    {this.createFilter("id", "Hand Id")}
                                    {this.createFilter("historicTournamentId", "Historic Tournament Id")}
                                    {this.createFilter("tableId", "Table Id")}
                                    {this.createFilter("tableIntegrationId", "Table Integration Id")}
                                    {this.createFilter("tableName", "Table Name")}
                                    {this.createFilter("bonusAmount", "Bonus Amount")}
                                    {this.createFilter("variant", "Variant")}
                                    {this.createFilter("betStrategyType", "Bet Type")}
                                    {this.createFilter("community", "Community Cards")}
                                    {this.createFilter("pots", "Pots")}
                                    {this.createFilter("capacity", "Table Size")}
                                    {this.createFilter("seatIds", "Seat ID")}
                                    {this.createFilter("playerNames", "Player Names")}
                                    {this.createFilter("playerIds", "Cubeia User Ids")}
                                    {this.createFilter("startTime", "Start Time")}
                                    {this.createFilter("endTime", "End Time")}

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ibox float-e-margins">
                        <div className="ibox-content">
                            <CustomTable isEnabled={this.isEnabled.bind(this)}
                                         className="table table-striped table-bordered table-hover dataTables-example dataTable">
                                <thead>
                                <tr role="row">

                                    <th data-id="id">Hand Id</th>
                                    <th data-id="tableId">Table Id</th>
                                    <th data-id="historicTournamentId">Historic Tournament Id</th>
                                    <th data-id="tableIntegrationId">Table Integration Id</th>
                                    <th data-id="tableName">Table Name</th>
                                    <th data-id="bonusAmount">Bonus Amount</th>
                                    <th data-id="variant">Variant</th>
                                    <th data-id="betStrategyType">Bet Type</th>
                                    <th data-id="community">Community Cards</th>
                                    <th data-id="pots">Pots</th>
                                    <th data-id="capacity">Table Size</th>
                                    <th data-id="seatIds">Seat</th>
                                    <th data-id="playerIds">PID</th>
                                    <th data-id="playerNames">Name</th>
                                    <th data-id="startTime">Start Time</th>
                                    <th data-id="endTime">End Time</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.getHands()}
                                </tbody>
                            </CustomTable>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    getPots(hand: HistoricHand) {
        let result = [];
        let potMap = new Map<number, GamePot>();

        hand.events.forEach((e: HandHistoryEvent) => {
            if (e.type == "PotUpdate") {
                var p: PotUpdate = e;
                if (!p.pots) {
                    return;
                }
                p.pots.forEach((gp: GamePot) => {
                    potMap.set(gp.potId, gp);
                });
            }
        });
        potMap.forEach((gp: GamePot) => {
            let str = gp.potSize + " " + hand.settings.currencyCode + "  (" + gp.players.length + ")";
            result.push(<li className="history-pots" key={gp.potId}>{str}</li>)
        });

        return result;
    }

    componentDidUpdate(prevProps: Props, prevState: State) {
        let splat = this.props.params.splat;
        if (!_.isEqual(prevProps.params.splat, splat)) {
            if (!splat || splat == "") {
                this.setState(({listRequest: this.initial} as any));
            } else {
                let req = {};
                extractPathParams(req, this.props.params);
                if (toPathParams(req) != toPathParams(this.state.request)) {
                    this.search(req as any, []);
                }
            }
        } else if (this.state.operatorId != prevState.operatorId) {
            this.search(this.state.request, [])
        }
        if (this.state.request && prevState.request && this.state.request.toDate < prevState.request.fromDate) {
            const newRequest = this.state.request;
            newRequest.fromDate = this.getMinDate().valueOf()
            this.setState({
                request: newRequest,
            })
        }
        if (this.state.request && prevState.request && this.state.request.fromDate > prevState.request.toDate) {
            const newRequest = this.state.request;
            newRequest.toDate = this.getMaxDate().valueOf()
            this.setState({
                request: newRequest,
            })
        }
    }

    getCommunityCards(hand: HistoricHand) {
        var cards = [];
        hand.events.forEach((e: HandHistoryEvent) => {
            if (e.type == "TableCardsDealt") {
                let tcd: TableCardsDealt = e;
                if (tcd.cards) {
                    cards = cards.concat(CardUtils.getCards(tcd.cards));
                }
            }
        });
        return cards;
    }

    getPlayerNames(hand: HistoricHand) {
        return hand.seats.map((p: Player) => {
            return (
                <li key={p.seatId + "name"}>
                    {p.name}
                </li>
            );
        });
    }

    getSeatIds(hand: HistoricHand) {
        return hand.seats.map((p: Player) => {
            return (
                <li key={p.seatId + "seat"}>
                    {"" + p.seatId}
                </li>
            );
        });
    }

    getPlayerIds(hand: HistoricHand) {
        return hand.seats.map((p: Player) => {
            return (
                <li key={p.seatId + "pid"}>{p.playerId}</li>
            );
        });
    }

    getBonusAmount(hand: HistoricHand) {
        const bonusPotEvent = hand.events.find((e: HandHistoryEvent) => e.type === "BonusPotEvent") as BonusPotEvent;
        return bonusPotEvent ? bonusPotEvent.bonusAmount : 0;
    }

    setTable(tableIntegrationId: string) {
        let req = Object.assign({}, this.state.request, {tableId: tableIntegrationId});
        this.search(req, this.state.history);
        setTimeout(() => this.setState({history: []}), 0);
    }

    getHistoricTournamentLink(hand: HistoricHand) {
        if (hand.historicTournamentId) {
            return (<Link to={"/historic-tournament/" + hand.historicTournamentId}>{hand.historicTournamentId}</Link>);
        }
        else {
            return "";
        }
    }

    private getHands() {

        return this.state.list.hands.map((hand: HistoricHand, i) => {
            return (
                <tr key={hand.id}>
                    <td data-id="id"><Link to={"/hand/" + hand.id}>{hand.id}</Link></td>
                    <td data-id="tableId">{hand.table && hand.table.tableId}</td>
                    <td data-id="historicTournamentId">{this.getHistoricTournamentLink(hand)}</td>
                    <td data-id="tableIntegrationId">{hand.table && hand.table.tableIntegrationId}</td>
                    <td data-id="tableName"><a
                        onClick={this.setTable.bind(this, hand.table.tableIntegrationId)}>{hand.table && hand.table.tableName}</a>
                    </td>
                    <th data-id="bonusAmount">{this.getBonusAmount(hand)}</th>
                    <td data-id="variant">{hand.settings && hand.settings.variant}</td>
                    <td data-id="betStrategyType">{hand.settings && hand.settings.betStrategyType}</td>
                    <td data-id="community">{this.getCommunityCards(hand)}</td>
                    <td data-id="pots">
                        <ul className="column-list">
                            {this.getPots(hand)}
                        </ul>
                    </td>

                    <td data-id="capacity">
                        {hand.settings.capacity}
                    </td>

                    <td data-id="seatIds">
                        <ul className="column-list">
                            {this.getSeatIds(hand)}
                        </ul>
                    </td>
                    <td data-id="playerIds">
                        <ul className="column-list">
                            {this.getPlayerIds(hand)}
                        </ul>
                    </td>
                    <td data-id="playerNames">
                        <ul className="column-list">
                            {this.getPlayerNames(hand)}
                        </ul>
                    </td>
                    <td data-id="startTime">{formatDate(hand.startTime)}</td>
                    <td data-id="endTime">{formatDate(hand.endTime)}</td>

                </tr>
            );
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/ui/view/poker/history/HandHistoryListView.tsx